import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Play, Image as ImageIcon, Video } from 'lucide-react';
import { cn } from '../lib/utils';

const mockImages = [
  '/images/renders/render1.jpg',
  '/images/renders/render2.jpg',
  '/images/renders/render3.jpg',
  '/images/renders/render4.jpg',
  '/images/renders/render5.jpg',
];

const fadeInUp = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } }
};

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [activeTab, setActiveTab] = useState('photos'); // 'photos' | 'videos'

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/gallery`);
        if (data && data.length > 0) {
          setImages(data.map(img => img.image_url.startsWith('http') ? img.image_url : `${process.env.REACT_APP_BACKEND_URL}${img.image_url}`));
        } else {
          setImages(mockImages);
        }
      } catch (err) {
        setImages(mockImages);
      }
    };
    fetchGallery();
  }, []);

  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50">
      <div className="container mx-auto px-6 max-w-7xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h4 className="text-blue-600 font-bold uppercase tracking-widest text-sm mb-3">Medya</h4>
          <h1 className="text-4xl md:text-6xl font-extrabold text-slate-900 mb-6">Galeri</h1>
          <p className="text-lg text-slate-600 font-medium max-w-2xl mx-auto mb-10">
            Projemizin güncel durumu, tanıtım filmlerimiz ve etkinliklerimizden kareler.
          </p>

          {/* TABS */}
          <div className="inline-flex bg-slate-200/50 p-1.5 rounded-2xl mb-12">
            <button 
              onClick={() => setActiveTab('photos')}
              className={cn(
                "flex items-center gap-2 px-8 py-3 rounded-xl font-bold text-sm transition-all duration-300",
                activeTab === 'photos' ? "bg-white text-blue-600 shadow-sm" : "text-slate-500 hover:text-slate-800"
              )}
            >
              <ImageIcon size={18} /> Fotoğraflar
            </button>
            <button 
              onClick={() => setActiveTab('videos')}
              className={cn(
                "flex items-center gap-2 px-8 py-3 rounded-xl font-bold text-sm transition-all duration-300",
                activeTab === 'videos' ? "bg-white text-blue-600 shadow-sm" : "text-slate-500 hover:text-slate-800"
              )}
            >
              <Video size={18} /> Videolar
            </button>
          </div>
        </motion.div>

        {activeTab === 'photos' ? (
          <motion.div 
            key="photos"
            initial="hidden"
            animate="visible"
            variants={{
              visible: { transition: { staggerChildren: 0.1 } }
            }}
            className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6"
          >
            {images.map((src, index) => (
              <motion.div 
                key={index}
                variants={fadeInUp}
                className="break-inside-avoid relative group rounded-3xl overflow-hidden cursor-pointer shadow-lg shadow-slate-200/50 border border-slate-100"
              >
                <img 
                  src={src} 
                  alt={`İsilkoop Gallery ${index + 1}`}
                  className="w-full h-auto object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-blue-900/0 group-hover:bg-blue-900/20 transition-colors duration-500 rounded-3xl"></div>
              </motion.div>
            ))}
          </motion.div>
        ) : (
          <motion.div 
            key="videos"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <div className="bg-white p-4 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100">
              <div className="w-full aspect-video rounded-2xl overflow-hidden bg-slate-900 relative">
                <iframe 
                  width="100%" 
                  height="100%" 
                  src="https://www.youtube.com/embed/Gsw55Ju4kiQ?autoplay=0" 
                  title="İSİLKOOP Tanıtım Filmi" 
                  frameBorder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-6 text-center">
                <h3 className="text-2xl font-bold text-slate-900 mb-2">İSİLKOOP Tanıtım Filmi</h3>
                <p className="text-slate-600 font-medium">Trakya'nın en büyük karma sanayi sitesi projemizi yakından tanıyın.</p>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
